// Experiences Grid Module
// Video hover effect has been removed as requested
var ExperiencesGrid = /** @class */ (function () {
    function ExperiencesGrid() {
        // No video hover functionality
    }
    return ExperiencesGrid;
}());
export { ExperiencesGrid };
// Auto-initialize if needed
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
        new ExperiencesGrid();
    });
}
else {
    new ExperiencesGrid();
}
